module.exports = __webpack_public_path__ + "img/trace.c42ea0df.gif";